<template>
  <section id="contact-us">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="title">
            <h3>
              <span style="color: #ff9955;">Our </span
              ><span style="color: #49ad43;">Birmingham office</span>
            </h3>
          </div>
          <p class="app-map-address">
            Office 14, Arion Business Centre,<br />
            118 High Street, Erdington, B23 6BG<br />
            Birmingham, United Kingdom
          </p>
        </div>
      </div>
    </div>
    <div
      class="googlemap"
      data-latlng="52.524089540287264, -1.837494572833078"
      data-scrollwheel="false"
      data-icon="/dist/assets/img/map_marker.png"
      data-zoom="17"
      data-theme="Default"
    >
      <div class="marker-content">
        <h5>OTANG CARE LTD</h5>
        <p>
          Office 14<br />
          Arion Business Centre<br />
          118 High Street<br />
          Erdington<br />
          B23 6BG<br />
          Birmingham<br />
          United Kingdom
        </p>
      </div>
    </div>
    <div class="contact">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <contact></contact>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Contact from "./Contact.vue";
export default {
  components: {
    Contact,
  },
  mounted() {
    window.initMap();
  },
};
</script>
